import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    width: '100%',
  },

  commission: {
    display: 'block',
    fontSize: 15,
    width: '100%',
    fontWeight: 400,
  },
}));

export default styles;
